<form [formGroup]="emailVerificationForm">
  <div class="form-floating">
    <input class="form-control px-4" type="email" autocomplete="off"
      [placeholder]="'EMAIL_VERIFICATION.EMAIL' | translate" formControlName="email" appNoArabicInput
      (keydown)="emailInputChanges($event)" />
    <label>{{ "EMAIL_VERIFICATION.EMAIL" | translate }}</label>
    <app-validation-message [control]="emailVerificationForm.get('email')"></app-validation-message>
  </div>
  @if(resendCodeTime == -1 && emailVerificationForm.get('otp')?.invalid){
  <button type="button" (click)="onClickEmailButton()" [disabled]="!emailVerificationForm.get('email')?.valid"
    class="btn-1 w-100 my-4">
      {{ (this.parentComponent === 'forgotPassword' 
        ? 'EMAIL_VERIFICATION.SEND_VERIFICATION_LINK_BUTTON' 
        : 'EMAIL_VERIFICATION.SEND_VERIFICATION_CODE_BUTTON') | translate 
      }}  </button>
  <!-- otp input fields should be disaplyed all the time except the begining -->
  }

@if (this.parentComponent !== "forgotPassword") {
  @if(resendCodeTime != -1){
  <div class="form-element">
    <label class="mb-3 mt-4">{{
      "EMAIL_VERIFICATION.ENTER_VERIFICATION_CODE" | translate
      }}</label>
    <div dir="ltr" class="mb-2">
      <ngx-otp-input #otpInput [options]="otpOptions" (otpComplete)="onOtpComplete($event)"
        (otpChange)="onOtpChange($event)"></ngx-otp-input>
    </div>

    <app-validation-message [control]="emailVerificationForm.get('otp')"></app-validation-message>
    <!--to show Resend code button -->
    @if(resendCodeTime === 0){
    <p class="click-here mb-4 mt-3 text-3 ibm-semibold">
      <span class="c-pointer" (click)="sendCodeToMail()">{{
        "EMAIL_VERIFICATION.RESEND_VERIFICATION_CODE" | translate
        }}</span>
    </p>
    <!--Showing cout down itself -->
    } @if(resendCodeTime > 0 && resendCodeTime !== -1){
    <div>
      <p class="text-blue-1 mb-4 mt-3 text-3 click-here">
        {{ "EMAIL_VERIFICATION.TIME_REMAINING" | translate }}:
        <span class="ibm-semibold">{{ resendCodeTime | minuteSecondTimeFormat }}</span>
      </p>
    </div>
    }
  </div>
  <!--When entering the otp to check if it is valid or not -->
  <!-- <button type="button" (click)="verifyOTP()" [disabled]="!emailVerificationForm.get('otp')?.valid"
    class="w-100 btn-1 fw-700 p-2 rounded-3 my-4">
    {{ "EMAIL_VERIFICATION.VERIFY_CODE_BUTTON" | translate }}
  </button> -->
  }
  }
</form>

@if(showCaptcha && parentComponent !== 'signIn'){
<app-captcha (allowAccess)="handleRecaptchaResponse($event)"></app-captcha>
}